import React from 'react';
import {
  Box,
  Typography,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Chip,
} from '@mui/material';
import { useThemeMode } from '../../contexts/ThemeModeContext';

const GeneralSettingsSection: React.FC = () => {
  const { preference, resolvedMode, setPreference } = useThemeMode();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        General
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Personalize your app experience.
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Color Scheme
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose how WaveScoop looks.
        </Typography>

        <RadioGroup
          value={preference}
          onChange={(e) => setPreference(e.target.value as any)}
          sx={{
            '& .MuiFormControlLabel-root': { mb: 1 },
          }}
        >
          <FormControlLabel value="light" control={<Radio />} label="Light" />
          <FormControlLabel value="dark" control={<Radio />} label="Dark" />
          <FormControlLabel value="system" control={<Radio />} label="Use device setting" />
        </RadioGroup>

        <Divider sx={{ my: 2 }} />
        <Typography variant="caption" color="text.secondary">
          Current mode:
        </Typography>{' '}
        <Chip size="small" label={resolvedMode === 'dark' ? 'Dark' : 'Light'} sx={{ ml: 1 }} />
      </Paper>

    </Box>
  );
};

export default GeneralSettingsSection;

